import qs from 'qs'
import axios from './http'
import global from '@/constants/Global.constants'

export default {
  login(params) { // 登录
    return axios.post(global.BASE_ACL + '/dealer/login', params, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' }
    })
  },
  logout(params) { // 注销
    return axios.post(global.BASE_ACL + '/dealer/logout', params)
  },
  registerRetail(params) { // 零售客户注册
    return axios.post(global.CMC_BASE + '/dealer/registerDealer', params)
  },
  getDataDict(params) { // 获取数据字典
    return axios.post(global.DMZ_BASE_INFO + '/common/getDictInfoList', params)
  },
  getFile(params) { // 获取区级数据
    return axios.post(global.MSI_BASE + '/file/findFile', params)
  },
  getCasePicture(params) { // 根据产品查案例图
    return axios.post(global.EC_BASE_FILE + '/findCasePicture', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/base.js